import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Error from "../Base-Component/Error/Error";
import { privateRouters, publicRouters } from "./allRoutes";
import MainLayout from "../Layouts/MainLayout/MainLayout";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";

function RouterData() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Error />} />

          {publicRouters.map((item, index) => (
            <Route
              key={index}
              path={item.path}
              element={<PublicRoute>{item.element}</PublicRoute>}
            />
          ))}

          {privateRouters.map((item, index) => (
            <Route
              key={index}
              path={item.path}
              element={
                <PrivateRoute>
                  <MainLayout>{item.element}</MainLayout>
                </PrivateRoute>
              }
            />
          ))}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default RouterData;
